import api from '../../services/file';
export default function (helper) {

  /**
   * Generated store module
   */
  helper.setApi(api);
  const types = helper.types('file');
  const state = helper.state();
  const getters = helper.getters();
  const actions = helper.actions({}, 'File');
  const mutations = helper.mutations({}, types, state);

  return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
}